module.exports = __webpack_public_path__ + "static/right-bg.48ca1da9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/log-in/right-bg.svg
// module id = 365
// module chunks = 180250571027784 188960337152066 192864653623833